import { PdfFileService } from './../../services/pdf-file.service';
import { DatePipe } from '@angular/common';
import { ExcelFileService } from './../../services/excel-file.service';
import { FileExportService } from './../../services/file-export.service';
import { ReportDateRangeDto } from './../../model/report-date-range-dto';
import { HttpclientService } from './../../services/httpclient.service';
import { MonthlyLocationDto } from './../../model/monthly-location-dto';
import { AppSettingService } from './../../services/app-setting.service';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { UnprocessedPoReportDto } from 'src/app/model/unprocessed-po-report-dto';
import { ReportDateRangeWrapperDto } from 'src/app/model/report-date-range-wrapper-dto';
import { PartnerDto } from 'src/app/model/partner-dto';

@Component({
  selector: 'app-unprocessed-po-report',
  templateUrl: './unprocessed-po-report.component.html',
  styleUrls: ['./unprocessed-po-report.component.css']
})
export class UnprocessedPoReportComponent implements OnInit {
  maxDateUpfr: moment.Moment;
  dateRangeUpfr;
  dateRangeUpfrStart;
  dateRangeUpfrEnd;
  exportModalUpfr: string;
  SelectAllRowModalUpfr: boolean;
  public mlrloading: boolean;
  public paginationConfigurationUpr;
  public mlrPaginationConfiguration;
  mlrPaginationcount = 25;
  unprocessedPoReportDtoList: UnprocessedPoReportDto[];
  unprocessedPoReportDtoSelectedList: UnprocessedPoReportDto[];
  selectedUnprocessedPoReportDtoList: any = [];
  reportDateRangeDto: ReportDateRangeDto;
  numberofexecution = 0;
  clearMlrSelection: UnprocessedPoReportDto[];
  sortArry: UnprocessedPoReportDto[];
  re: ReportDateRangeWrapperDto;
  reportDateRanges: ReportDateRangeDto[] = [];
  partnerModal;
  partnerDtoList: PartnerDto[];

isCreateDateUpArrow: boolean;
isCreateDateDownArrow: boolean;
isFileIdUpArrow: boolean;
isFileIdDownArrow: boolean;
isPoNumberUpArrow: boolean;
isPoNumberDownArrow: boolean;
isFileNameUpArrow: boolean;
isFileNameDownArrow: boolean;
isPartnerUpArrow: boolean;
isPartnerDownArrow: boolean;
isDocumentTypeUpArrow: boolean;
isDocumentTypeDownArrow: boolean;
isStatusUpArrow: boolean;
isStatusDownArrow: boolean;
isSubStatusUpArrow: boolean;
isSubStatusDownArrow: boolean;
isOnHoldReasonUpArrow: boolean;
isOnHoldReasonDownArrow: boolean;


  constructor(public appSettingService: AppSettingService, private httpclientService: HttpclientService,
              public fileExportService: FileExportService, public excelFileService: ExcelFileService, public datePipe: DatePipe,
              public pdfFileService: PdfFileService, private pipe: PoOrderByPipe) { }

  ngOnInit() {
    this.unprocessedPoReportDtoList = [];
    this.partnerModal = -1;
    this.mlrPaginationConfiguration = { currentPage: '25 per page', itemsPerPage: '25' };
    this.getPartnerDataList();
    this.maxDateUpfr = moment().add(0, 'days');
    this.exportModalUpfr = this.appSettingService.exportList[0];
    this.paginationConfigurationUpr = { currentPage: '25 per page', itemsPerPage: '25' };
    this.dateRangeUpfr = '';
    this.initialSortValue();
  }
/****************************************************** Clear Selction Start ***************************************************/


initialSortValue() {
  this.isCreateDateUpArrow = true;
  this.isCreateDateDownArrow = true;
  this.isFileIdUpArrow = true;
  this.isFileIdDownArrow = true;
  this.isPoNumberUpArrow = true;
  this.isPoNumberDownArrow = true;
  this.isFileNameUpArrow = true;
  this.isFileNameDownArrow = true;
  this.isPartnerUpArrow = true;
  this.isPartnerDownArrow = true;
  this.isDocumentTypeUpArrow = true;
  this.isDocumentTypeDownArrow = true;
  this.isStatusUpArrow = true;
  this.isStatusDownArrow = true;
  this.isSubStatusUpArrow = true;
  this.isSubStatusDownArrow = true;
  this.isOnHoldReasonUpArrow = true;
  this.isOnHoldReasonDownArrow = true;
}
  clearAllSelection() {
     this.SelectAllRowModalUpfr = false;
     this.initialSortValue();
    // this.clearMlrSelection = [];
    // this.monthlyLocationDtoList.forEach(pdto => {
    //   pdto.rowCheck = false;
    //   this.clearMlrSelection.push(pdto);
    // });
    // this.monthlyLocationDtoList = this.clearMlrSelection;
  }
/****************************************************** Clear Selction End ***************************************************/

  getPartnerDataList() {
    this.mlrloading = true;
    if (this.appSettingService.partnerMSOGlobelList === null || this.appSettingService.partnerMSOGlobelList === undefined ) {
      this.httpclientService.getPartnerList().subscribe(
        data => {
          this.appSettingService.partnerMSOGlobelList = data;
          this.partnerDtoList = data;
          this.mlrloading = false;
        }
      );

    //  console.log('Partner is null from backend' + this.appSettingService.partnerMSOGlobelList);
      } else {
        this.partnerDtoList = this.appSettingService.partnerMSOGlobelList;
        this.mlrloading = false;
      //  console.log('Partner is not null from frontend' + this.appSettingService.partnerMSOGlobelList);
      }
  }



  /****************************************************** Date Picker Block Start ***************************************************/

selectePartner() {
  this.unprocessedPoReportDtoList = [];
  // if (this.partnerModal !== -1) {
  this.dateOnChangeUpr();
  // }
}
dateOnChangeUpr() {
  this.fileExportService.selectedPbjReportData = [];
 // this.clearAllSelection();
  if (this.dateRangeUpfr.dateRangeUpfrStart !== undefined &&
    this.dateRangeUpfr.dateRangeUpfrStart !== null) {
    this.mlrloading = true;

    this.reportDateRanges = [{
            start: this.dateRangeUpfr.dateRangeUpfrStart.format('YYYY-MM-DD'),
            end: this.dateRangeUpfr.dateRangeUpfrEnd.format('YYYY-MM-DD'),
          },
    ];

    console.log(this.reportDateRanges);
    this.re = {
      partnerId: this.partnerModal,
      reportDateRanges: this.reportDateRanges,
    };
    this.httpclientService.getUnProcessReport(this.re).subscribe(
      data => {
        this.mlrloading = false;
        this.clearAllSelection();
        this.unprocessedPoReportDtoList = data;

      }
    );
  }
}
/****************************************************** Date Picker Block End ***************************************************/


/****************************************************** Row Selection Start ***************************************************/
mlrOnSelectParticularRow(selectedItem: any, values: any) {
  if (values.currentTarget.checked) {
    this.fileExportService.selectedUnprocessedPoReportData.push(selectedItem);
  } else if (!values.currentTarget.checked) {
    this.fileExportService.selectedUnprocessedPoReportData =
    this.fileExportService.selectedUnprocessedPoReportData.filter(obj => obj !== selectedItem);
  }
  if (this.fileExportService.selectedUnprocessedPoReportData.length === this.unprocessedPoReportDtoList.length) {
    this.SelectAllRowModalUpfr = true;
  } else {
    this.SelectAllRowModalUpfr = false;
  }
}

mlrOnSelectAllRow(values: any) {
this.selectedUnprocessedPoReportDtoList = [];
if (values.currentTarget.checked) {
  this.unprocessedPoReportDtoList.forEach(pdto => {
    pdto.rowCheck = true;
    this.selectedUnprocessedPoReportDtoList.push(pdto);
  });
  this.unprocessedPoReportDtoList = this.selectedUnprocessedPoReportDtoList;
  this.fileExportService.selectedUnprocessedPoReportData = this.selectedUnprocessedPoReportDtoList;
} else {
  this.unprocessedPoReportDtoList.forEach(pdto => {
    pdto.rowCheck = false;
    this.selectedUnprocessedPoReportDtoList.push(pdto);
  });
  this.unprocessedPoReportDtoList = this.selectedUnprocessedPoReportDtoList;
  this.fileExportService.selectedUnprocessedPoReportData = [];
}
}
/****************************************************** Row Selection End ***************************************************/



/****************************************************** Table Sort Start ***************************************************/
changeSortOrderUpfr(exportData) {
  this.exportModalUpfr = exportData;
}

onChangeMlrSort(event: any, upDown: boolean, propertyName: string) {
  if (propertyName === 'dateTimeOfCreation' ) {
    this.isFileIdUpArrow = true;
    this.isFileIdDownArrow = true;
    this.isPoNumberUpArrow = true;
    this.isPoNumberDownArrow = true;
    this.isFileNameUpArrow = true;
    this.isFileNameDownArrow = true;
    this.isPartnerUpArrow = true;
    this.isPartnerDownArrow = true;
    this.isDocumentTypeUpArrow = true;
    this.isDocumentTypeDownArrow = true;
    this.isStatusUpArrow = true;
    this.isStatusDownArrow = true;
    this.isSubStatusUpArrow = true;
    this.isSubStatusDownArrow = true;
    this.isOnHoldReasonUpArrow = true;
    this.isOnHoldReasonDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, upDown);
  this.unprocessedPoReportDtoList = [];
  this.unprocessedPoReportDtoList = this.sortArry;
  this.isCreateDateUpArrow = !this.isCreateDateUpArrow;
  this.isCreateDateDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, upDown);
this.unprocessedPoReportDtoList = [];
this.unprocessedPoReportDtoList = this.sortArry;
this.isCreateDateDownArrow = !this.isCreateDateDownArrow;
this.isCreateDateUpArrow = true;
}
} else if (propertyName === 'fileId' ) {
  this.isCreateDateUpArrow = true;
  this.isCreateDateDownArrow = true;
  this.isPoNumberUpArrow = true;
  this.isPoNumberDownArrow = true;
  this.isFileNameUpArrow = true;
  this.isFileNameDownArrow = true;
  this.isPartnerUpArrow = true;
  this.isPartnerDownArrow = true;
  this.isDocumentTypeUpArrow = true;
  this.isDocumentTypeDownArrow = true;
  this.isStatusUpArrow = true;
  this.isStatusDownArrow = true;
  this.isSubStatusUpArrow = true;
  this.isSubStatusDownArrow = true;
  this.isOnHoldReasonUpArrow = true;
  this.isOnHoldReasonDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, true);
  this.unprocessedPoReportDtoList = [];
  this.unprocessedPoReportDtoList = this.sortArry;
  this.isFileIdUpArrow = !this.isFileIdUpArrow;
  this.isFileIdDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, false);
this.unprocessedPoReportDtoList = [];
this.unprocessedPoReportDtoList = this.sortArry;
this.isFileIdDownArrow = !this.isFileIdDownArrow;
this.isFileIdUpArrow = true;
}
} else if (propertyName === 'purchaseOrderNumber' ) {
  this.isCreateDateUpArrow = true;
  this.isCreateDateDownArrow = true;
  this.isFileIdUpArrow = true;
  this.isFileIdDownArrow = true;
  this.isFileNameUpArrow = true;
  this.isFileNameDownArrow = true;
  this.isPartnerUpArrow = true;
  this.isPartnerDownArrow = true;
  this.isDocumentTypeUpArrow = true;
  this.isDocumentTypeDownArrow = true;
  this.isStatusUpArrow = true;
  this.isStatusDownArrow = true;
  this.isSubStatusUpArrow = true;
  this.isSubStatusDownArrow = true;
  this.isOnHoldReasonUpArrow = true;
  this.isOnHoldReasonDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, true);
  this.unprocessedPoReportDtoList = [];
  this.unprocessedPoReportDtoList = this.sortArry;
  this.isPoNumberUpArrow = !this.isPoNumberUpArrow;
  this.isPoNumberDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, false);
this.unprocessedPoReportDtoList = [];
this.unprocessedPoReportDtoList = this.sortArry;
this.isPoNumberDownArrow = !this.isPoNumberDownArrow;
this.isPoNumberUpArrow = true;
}
} else if (propertyName === 'fileName' ) {
  this.isCreateDateUpArrow = true;
  this.isCreateDateDownArrow = true;
  this.isFileIdUpArrow = true;
  this.isFileIdDownArrow = true;
  this.isPoNumberUpArrow = true;
  this.isPoNumberDownArrow = true;
  this.isPartnerUpArrow = true;
  this.isPartnerDownArrow = true;
  this.isDocumentTypeUpArrow = true;
  this.isDocumentTypeDownArrow = true;
  this.isStatusUpArrow = true;
  this.isStatusDownArrow = true;
  this.isSubStatusUpArrow = true;
  this.isSubStatusDownArrow = true;
  this.isOnHoldReasonUpArrow = true;
  this.isOnHoldReasonDownArrow = true;
  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, true);
  this.unprocessedPoReportDtoList = [];
  this.unprocessedPoReportDtoList = this.sortArry;
  this.isFileNameUpArrow = !this.isFileNameUpArrow;
  this.isFileNameDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, false);
this.unprocessedPoReportDtoList = [];
this.unprocessedPoReportDtoList = this.sortArry;
this.isFileNameDownArrow = !this.isFileNameDownArrow;
this.isFileNameUpArrow = true;
}
} else if (propertyName === 'partner' ) {
  this.isCreateDateUpArrow = true;
  this.isCreateDateDownArrow = true;
  this.isFileIdUpArrow = true;
  this.isFileIdDownArrow = true;
  this.isPoNumberUpArrow = true;
  this.isPoNumberDownArrow = true;
  this.isFileNameUpArrow = true;
  this.isFileNameDownArrow = true;
  this.isDocumentTypeUpArrow = true;
  this.isDocumentTypeDownArrow = true;
  this.isStatusUpArrow = true;
  this.isStatusDownArrow = true;
  this.isSubStatusUpArrow = true;
  this.isSubStatusDownArrow = true;
  this.isOnHoldReasonUpArrow = true;
  this.isOnHoldReasonDownArrow = true;

  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, true);
  this.unprocessedPoReportDtoList = [];
  this.unprocessedPoReportDtoList = this.sortArry;
  this.isPartnerUpArrow = !this.isPartnerUpArrow;
  this.isPartnerDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, false);
this.unprocessedPoReportDtoList = [];
this.unprocessedPoReportDtoList = this.sortArry;
this.isPartnerDownArrow = !this.isPartnerDownArrow;
this.isPartnerUpArrow = true;
}
} else if (propertyName === 'documentType' ) {
  this.isCreateDateUpArrow = true;
  this.isCreateDateDownArrow = true;
  this.isFileIdUpArrow = true;
  this.isFileIdDownArrow = true;
  this.isPoNumberUpArrow = true;
  this.isPoNumberDownArrow = true;
  this.isFileNameUpArrow = true;
  this.isFileNameDownArrow = true;
  this.isPartnerUpArrow = true;
  this.isPartnerDownArrow = true;
  this.isStatusUpArrow = true;
  this.isStatusDownArrow = true;
  this.isSubStatusUpArrow = true;
  this.isSubStatusDownArrow = true;
  this.isOnHoldReasonUpArrow = true;
  this.isOnHoldReasonDownArrow = true;

  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, true);
  this.unprocessedPoReportDtoList = [];
  this.unprocessedPoReportDtoList = this.sortArry;
  this.isDocumentTypeUpArrow = !this.isDocumentTypeUpArrow;
  this.isDocumentTypeDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, false);
this.unprocessedPoReportDtoList = [];
this.unprocessedPoReportDtoList = this.sortArry;
this.isDocumentTypeDownArrow = !this.isDocumentTypeDownArrow;
this.isDocumentTypeUpArrow = true;
}
} else if (propertyName === 'status' ) {
  this.isCreateDateUpArrow = true;
  this.isCreateDateDownArrow = true;
  this.isFileIdUpArrow = true;
  this.isFileIdDownArrow = true;
  this.isPoNumberUpArrow = true;
  this.isPoNumberDownArrow = true;
  this.isFileNameUpArrow = true;
  this.isFileNameDownArrow = true;
  this.isPartnerUpArrow = true;
  this.isPartnerDownArrow = true;
  this.isDocumentTypeUpArrow = true;
  this.isDocumentTypeDownArrow = true;
  this.isSubStatusUpArrow = true;
  this.isSubStatusDownArrow = true;
  this.isOnHoldReasonUpArrow = true;
  this.isOnHoldReasonDownArrow = true;

  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, true);
  this.unprocessedPoReportDtoList = [];
  this.unprocessedPoReportDtoList = this.sortArry;
  this.isStatusUpArrow = !this.isStatusUpArrow;
  this.isStatusDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, false);
this.unprocessedPoReportDtoList = [];
this.unprocessedPoReportDtoList = this.sortArry;
this.isStatusDownArrow = !this.isStatusDownArrow;
this.isStatusUpArrow = true;
}
} else if (propertyName === 'subStatus' ) {
  this.isCreateDateUpArrow = true;
  this.isCreateDateDownArrow = true;
  this.isFileIdUpArrow = true;
  this.isFileIdDownArrow = true;
  this.isPoNumberUpArrow = true;
  this.isPoNumberDownArrow = true;
  this.isFileNameUpArrow = true;
  this.isFileNameDownArrow = true;
  this.isPartnerUpArrow = true;
  this.isPartnerDownArrow = true;
  this.isDocumentTypeUpArrow = true;
  this.isDocumentTypeDownArrow = true;
  this.isStatusUpArrow = true;
  this.isStatusDownArrow = true;
  this.isOnHoldReasonUpArrow = true;
  this.isOnHoldReasonDownArrow = true;

  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, true);
  this.unprocessedPoReportDtoList = [];
  this.unprocessedPoReportDtoList = this.sortArry;
  this.isSubStatusUpArrow = !this.isSubStatusUpArrow;
  this.isSubStatusDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, false);
this.unprocessedPoReportDtoList = [];
this.unprocessedPoReportDtoList = this.sortArry;
this.isSubStatusDownArrow = !this.isSubStatusDownArrow;
this.isSubStatusUpArrow = true;
}
} else if (propertyName === 'onHoldReason' ) {
  this.isCreateDateUpArrow = true;
  this.isCreateDateDownArrow = true;
  this.isFileIdUpArrow = true;
  this.isFileIdDownArrow = true;
  this.isPoNumberUpArrow = true;
  this.isPoNumberDownArrow = true;
  this.isFileNameUpArrow = true;
  this.isFileNameDownArrow = true;
  this.isPartnerUpArrow = true;
  this.isPartnerDownArrow = true;
  this.isDocumentTypeUpArrow = true;
  this.isDocumentTypeDownArrow = true;
  this.isStatusUpArrow = true;
  this.isStatusDownArrow = true;
  this.isSubStatusUpArrow = true;
  this.isSubStatusDownArrow = true;

  if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, true);
  this.unprocessedPoReportDtoList = [];
  this.unprocessedPoReportDtoList = this.sortArry;
  this.isOnHoldReasonUpArrow = !this.isOnHoldReasonUpArrow;
  this.isOnHoldReasonDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.unprocessedPoReportDtoList, propertyName, false);
this.unprocessedPoReportDtoList = [];
this.unprocessedPoReportDtoList = this.sortArry;
this.isOnHoldReasonDownArrow = !this.isOnHoldReasonDownArrow;
this.isOnHoldReasonUpArrow = true;
}
}

}

/****************************************************** Table Sort End ***************************************************/



/****************************************************** File Export Start ***************************************************/
modalPopup : boolean=false;
modalPopupString: string;
pressingOK(){
  this.modalPopup=false;
}

mlrExportFile() {
  if (this.unprocessedPoReportDtoList === null || this.unprocessedPoReportDtoList.length === 0) {
    this.modalPopupString="No Data to Export";
    this.modalPopup=true;
  } else  if (this.fileExportService.selectedUnprocessedPoReportData.length === 0 && this.unprocessedPoReportDtoList.length !== 0) {
    if (this.exportModalUpfr === 'PDF') {
      this.pdfFileService.exportPdfUnProcessReportAll('Unprocessed Files Report ', this.unprocessedPoReportDtoList);
    } else if (this.exportModalUpfr === 'Excel') {
      this.selectedUnprocessedPoReportDtoList = [];
      this.unprocessedPoReportDtoList.forEach(pdto => {
          let createDateTime: any;
          createDateTime = this.datePipe.transform(pdto.dateTimeOfCreation, this.appSettingService.globelDateTimeFormat);
          this.selectedUnprocessedPoReportDtoList.push({
            'Create Date' : `` + createDateTime, 'File Id': `${pdto.fileId}`,
            'PO Number': `${pdto.purchaseOrderNumber}`, 'File Name': `${pdto.fileName}`,
            Partner : `${pdto.partner}`, 'Document Type': `${pdto.documentType}`,
             Status : `${pdto.status}`, 'Sub Status': `${pdto.subStatus}`,
            'On Hold Reason': `${pdto.onHoldReason}`
          });
      });
      this.excelFileService.exportUnprocessedExcel(this.selectedUnprocessedPoReportDtoList, 'Unprocessed Files Report');
    }
  } else {
    if (this.exportModalUpfr === 'PDF') {
      this.pdfFileService.exportPdfUnProcessReport('Unprocessed Files Report ');
    } else if (this.exportModalUpfr === 'Excel') {
      this.selectedUnprocessedPoReportDtoList = [];
      this.fileExportService.selectedUnprocessedPoReportData.forEach(pdto => {
        if (pdto.rowCheck) {
          let createDateTime: any;
          createDateTime = this.datePipe.transform(pdto.dateTimeOfCreation, this.appSettingService.globelDateTimeFormat);
          this.selectedUnprocessedPoReportDtoList.push({
            'Create Date' : `` + createDateTime, 'File Id': `${pdto.fileId}`,
            'PO Number' : `${pdto.purchaseOrderNumber}`, 'File Name' : `${pdto.fileName}`,
            'Partner' : `${pdto.partner}`, 'Document Type' : `${pdto.documentType}`,
             'Status' : `${pdto.status}`, 'Sub Status' : `${pdto.subStatus}`,
            'On Hold Reason' : `${pdto.onHoldReason}`
          });
        }
      });
      this.excelFileService.exportUnprocessedExcel(this.selectedUnprocessedPoReportDtoList, 'Unprocessed Files Report');
    }
  }
}
/****************************************************** File Export End ***************************************************/



/****************************************************** Date Picker Block Start ***************************************************/
monthlyLocationDateChange() {
  this.fileExportService.selectedUnprocessedPoReportData = [];
 // this.clearAllSelection();
  if (this.dateRangeUpfr.monthlyLocationDateRangeStart !== undefined &&
    this.dateRangeUpfr.monthlyLocationDateRangeStart !== null) {
    this.mlrloading = true;
    this.reportDateRangeDto = {
      start: this.dateRangeUpfr.monthlyLocationDateRangeStart.format('YYYY-MM-DD'),
      end: this.dateRangeUpfr.monthlyLocationDateRangeEnd.format('YYYY-MM-DD'),
    };
    this.httpclientService.getUnProcessReport(this.reportDateRangeDto).subscribe(
      data => {
        this.mlrloading = false;
        this.clearAllSelection();
        this.unprocessedPoReportDtoList = data;
      }
    );
  }
}
/****************************************************** Date Picker Block End ***************************************************/


/****************************************************** Pagination Start ***************************************************/
mlrOnChangePagination(value) {

  this.mlrPaginationConfiguration.itemsPerPage = value;
  this.mlrPaginationcount = value;
}

mlrPageOnChanged(event) {
  this.mlrPaginationConfiguration.currentPage = event;
}
/****************************************************** Pagination End ***************************************************/


}
